import { Box, Collapse, Link, Stack, Typography } from "@mui/material";
import { useState, type ReactNode } from "react";

/**
 * The resolve dialogs' "Preview" block, collapsed by default: what each source
 * becomes and the status save leaves. `footer` stays visible either way, for
 * the reason Save is disabled.
 */
export function ResultSection({ children, footer }: { children: ReactNode; footer?: ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <Box>
      <Stack direction="row" spacing={1} alignItems="baseline">
        <Typography variant="body1" sx={{ fontWeight: 600 }}>
          Preview
        </Typography>
        <Link
          component="button"
          type="button"
          variant="body2"
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
        >
          {open ? "Hide" : "Show"}
        </Link>
      </Stack>
      <Collapse in={open}>{children}</Collapse>
      {footer}
    </Box>
  );
}
